export function FtloLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="90 112 520 260"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path d="m96.556,164.763l101.124-9.819v30.764l-65.138,6.315v36.674l58.762-5.686v30.763l-58.762,5.676v61.276l-35.986,3.465v-159.429Z" />
      <path d="m258.707,180.246l-45.324,4.394v-31.22l127.088-12.34v31.24l-45.553,4.416v128.355l-36.211,3.487v-128.332Z" />
      <path d="m356.25,139.548l36.211-3.516v127.278l80.4-7.755v32.402l-116.611,11.229v-159.638Z" />
      <path d="m481.368,232.6v-50.66c0-32.861,24.369-59.873,61.037-63.434s61.04,18.733,61.04,51.614v50.691c0,32.878-24.369,59.885-61.04,63.415-36.668,3.53-61.037-18.769-61.037-51.627Zm86.091-10.142v-47.029c0-12.786-8.882-23.795-25.054-22.227-16.169,1.567-25.051,14.295-25.051,27.078v47.017c0,13.011,8.882,23.793,25.051,22.233s25.054-14.058,25.054-27.072Z" />
      <polygon points="472.28 354.137 356.83 365.866 356.83 333.278 472.28 321.549 472.28 354.137" />
    </svg>
  );
}
